<tam-dialog tid="note_dialog" [hidden]="isDialogHidden" (mousedown)="onClickSetEventValue($event)"
    (click)="onClickSetEventValue($event)" class="note-dialog threaddetail-sidesheet-status"
    (closeminDialog)="closemin()" [opened]="opened" [dialogWidth]="dialogWidth" [titleName]="titleName"
    (keydown.esc)="onEnter($event)" [closable]="attachmentUploading||attachmentRenaming" (keyup)="keySend($event)"
    [config]="dialogConfig" (containerEvent)="onContainerEvent($event)" #dialogRef>
    <ng-template #title *ngIf="!isPlugInEditNoteMode&&!isPopupEntry">
        <span class="dialog-title">{{titleName}}</span>
        <smart-icon class="dialog-min dark" name="substract" (click)="windowMinimize()"></smart-icon>
        <smart-icon *ngIf="!isHidePopOut" class="dialog-popup dark" name="note-dialog-popup-entry"
            (click)="popupEntry($event)" title="Pop out"
            [hidden]="isPopupEntry||attachmentUploading||attachmentRenaming">
        </smart-icon>
        <smart-icon class="dialog-close dark" name="close" (click)="clickClose('cancel', $event)"
            [hidden]="attachmentUploading||attachmentRenaming">
        </smart-icon>
    </ng-template>

    <ng-template #body>
        <div class="note-content" [ngClass]="{'single-layer-content':isSingleTemplate}">
            <div class="flex-box" [ngClass]="{'addin-privacy':isSingleTemplate}">
                <div [ngClass]="{'pull-left-privacy':isPrivacy}" class="pull-left" tid="note_type">
                    <span *ngIf="!isSingleTemplate">Note Type &nbsp;&nbsp;&nbsp;&nbsp; </span>
                    <kendo-dropdownlist [popupSettings]="{appendTo: viewContainer}" #dropDownEntryType
                        [data]="_noteTypes" [(ngModel)]="_noteTypeDefalult" [textField]="'name'" class="entity-type"
                        [valueField]="'id'" [filterable]="true" (selectionChange)="selectionChange($event)"
                        (filterChange)="handleFilter($event,dropDownEntryType)" (focus)="dropDownEntryType.toggle(true)"
                        (mousedown)="$event.preventDefault()">
                    </kendo-dropdownlist>
                    <tam-priority-input class="priority-input" *ngIf="isSingleTemplate&&sentimentConfig"
                        [config]="sentimentConfig" [valueChangeSubject]="valueChangeSubject">
                    </tam-priority-input>
                </div>
                <div class="pull-right" [ngClass]="{'pull-right-privacy':isPrivacy}"
                    *ngIf="privacyEnabled &&(_noteAction =='create-note'||isDraft)" tid="note_privacy">
                    <label class="privacy-label">
                        <span>Privacy {{isSingleTemplate?":":""}}&nbsp;&nbsp;&nbsp;&nbsp; </span>
                        <kendo-dropdownlist [popupSettings]="{appendTo: viewContainer}" #dropDownEl
                            [data]="_privacyList" [(ngModel)]="privacyListDefalult" [textField]="'name'"
                            [valueField]="'id'" (selectionChange)="privacyChanged($event)" [filterable]="true"
                            (filterChange)="privacyHandleFilter($event)" (focus)="dropDownEl.toggle(true)"
                            (mousedown)="$event.preventDefault()">
                        </kendo-dropdownlist>
                    </label>
                </div>
            </div>
            <div *ngIf="isNeedReload"><label class="template-change">Template configuration has been updated by other
                    user, save directly might
                    cause data lost,
                    please <span class="template-reload" (click)="onClickReload()">reload.</span></label></div>
            <hr [ngClass]="{'hr-one-layer':isSingleTemplate}">
            <label *ngIf="isOutlookAddinMode" tam-checkbox (click)="onCheckBoxClick()" [(ngModel)]="checkboxValue"
                class="checkbox">{{'addin.this_is_event' | stringLiterals}}</label>
            <div class="template-container">
                <!--Multiple combinations  layouts-->
                <tam-template *ngIf="!isSingleTemplate" [config]="tplConfig" [valueChangeSubject]="valueChangeSubject"
                    (publishEvent)="publish()" (saveDraftEvent)="saveAsDraft()" [noteBodySubject]="_noteBodySubject"
                    [autoTagSubject]="autoTagSubject" [publishSubject]="_publishSubject$">
                </tam-template>
                <!--single layer layouts-->
                <tam-single-template *ngIf="isSingleTemplate" [config]="singleLayerConfig"
                    [valueChangeSubject]="valueChangeSubject" (publishEvent)="publish()"
                    (saveDraftEvent)="saveAsDraft()" [noteBodySubject]="_noteBodySubject"
                    [autoTagSubject]="autoTagSubject" [publishSubject]="_publishSubject$"></tam-single-template>
            </div>
            <div class="upload-container" *ngIf="!clickHideControl">
                <note-attachments [config]="noteAttachmentsConfig">
                </note-attachments>
            </div>
        </div>
        <input tabindex="-1" id="hidden-note-dialog" class="hidden-input" value={{dialogWidthForPlugin}} />
        <input tabindex="-1" id="hidden-note-dialog-open-status" class="hidden-input"
            value={{isDialogClosedForPlugin}} />
    </ng-template>
    <ng-template #footer *ngIf="!isOfficeAddinMode">
        <div class="footer-container">
            <div *ngIf="isPlugInEditNoteMode" class="tmlicon-info-plugin" title="{{domainUrl}}" kendoTooltip
                position="bottom" tooltipClass="tooltip-adjust-right">
                <smart-icon class="tmlicon-lg tmlicon-info dark" name="info-o"></smart-icon>
            </div>
            <div *ngIf="!isAutoSaving&&autoSaveTime&&!isSingleTemplate" class="auto-save-time">Autosaved at
                {{autoSaveTime|date:'hh:mm a'}}
            </div>
            <div *ngIf="!isAutoSaving&&autoSaveTime&&isSingleTemplate" class="auto-save-time">{{ addinAutoSavedTip}}
            </div>
            <div *ngIf="isAutoSaving" class="auto-save-time">{{ addinAutoSavingTip}}</div>
            <div class="button-container">
                <button tam-button tamType="tertiary" tamSize="normal" class="dialog-button dialog-cancel"
                    (click)="onCancelBtnClick($event)" [disabled]="isAutoSaving&&!editingEntryId">{{cancelTip}}</button>
                <button *ngIf="canSaveAsDraft" tam-button tamType="secondary" tamSize="normal"
                    class="dialog-button dialog-save" (click)="saveAsDraft()" [tamLoading]="publishButtonHasBeenClicked"
                    [disabled]="attachmentUploading||attachmentRenaming||publishButtonHasBeenClicked||(isAutoSaving&&!editingEntryId)">{{addinSaveAsDraftTip}}</button>
                <button tam-button tamType="primary" tamSize="normal" class="dialog-button dialog-publish"
                    (click)="publish()" [tamLoading]="publishButtonHasBeenClicked"
                    [disabled]="attachmentUploading||attachmentRenaming||publishButtonHasBeenClicked||(isAutoSaving&&!editingEntryId)">{{publishTip}}</button>
            </div>
        </div>
    </ng-template>
    <ng-template #footer *ngIf="isOfficeAddinMode">
        <div class="footer-container">
            <div *ngIf="!isAutoSaving&&autoSaveTime&&!isSingleTemplate" class="addin-auto-save-time add-in-tip">
                Autosaved at
                {{autoSaveTime|date:'hh:mm a'}}
            </div>
            <div *ngIf="!isAutoSaving&&autoSaveTime&&isSingleTemplate" class="addin-auto-save-time add-in-tip">
                {{ addinAutoSavedTip}}
            </div>
            <div *ngIf="isAutoSaving" class="addin-auto-save-time">{{ addinAutoSavingTip}}</div>
            <div class="addin-button-set addin-button-container">
                <button tam-button tamType="tertiary" tamSize="sm" class="dialog-cancel add-in-button"
                    (click)="onCancelBtnClick($event)" [disabled]="isAutoSaving&&!editingEntryId">{{cancelTip}}</button>
                <button *ngIf="canSaveAsDraft" tam-button tamType="secondary" tamSize="sm"
                    class="dialog-save add-in-draft" (click)="saveAsDraft()" [tamLoading]="publishButtonHasBeenClicked"
                    [disabled]="attachmentUploading||attachmentRenaming||publishButtonHasBeenClicked||(isAutoSaving&&!editingEntryId)">{{addinSaveAsDraftTip}}</button>
                <button tam-button tamType="primary" tamSize="sm" class="dialog-publish add-in-button"
                    (click)="publish()" [tamLoading]="publishButtonHasBeenClicked"
                    [disabled]="attachmentUploading||attachmentRenaming||publishButtonHasBeenClicked||(isAutoSaving&&!editingEntryId)">{{publishTip}}</button>
            </div>
        </div>
    </ng-template>
</tam-dialog>

<div class="addin-notification-container" *ngIf="isDialogHidden">
    <div class="header-line split"></div>
    <div class="content">
        <div class="note-created-success">{{ addinSuccessTip}}</div>
        <div class="icon-check">
            <smart-icon class="aacl-icon" name="check-circle"></smart-icon>
        </div>
        <div class="subject" (click)="onSubjectClick()">{{addinSubject}}</div>
    </div>
    <div *ngIf="isShowBtnClose" class="footer-line split"></div>
    <div *ngIf="isShowBtnClose" class="footer">
        <button tam-button tamType="primary" tamSize="normal" class="dialog-button"
            (click)="onCloseBtnClick()">{{'addin.close'
            | stringLiterals}}</button>
    </div>
</div>